import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useTranslation } from 'react-i18next';
import { IDashboard } from '../../interfaces/dashboard.ts';

// Y-Axis values
const CustomLegend = (props: any) => {
	const { payload } = props;

	return (
		<div className="flex gap-x-5">
			{payload?.map((entry: any, index: number) => (
				<div key={`item-${index}`} className="mb-8 flex items-center">
					<div
						className="me-2 ms-2 h-4 w-4 rounded-full"
						style={{
							backgroundColor: entry?.payload?.fill,
							marginRight: 10,
						}}
					/>
					<span className="text-sm text-grey-600">{entry.value}</span>
				</div>
			))}
		</div>
	);
};

interface CustomBarChartProps {
	data: IDashboard | undefined;
}

const CustomBarChart: React.FC<CustomBarChartProps> = ({ data }) => {
	const { t } = useTranslation();

	const max = Math.max(...Object.entries(data?.activities ?? {})?.map(([_, val]) => Math.max(val?.received, val?.given)));

	const dataChart = Object.entries(data?.activities ?? {})?.map(([date, val]) => ({ name: new Date(date ?? '')?.toLocaleString('fa-IR', { weekday: 'long', calendar: 'persian' }), pinkBar: val?.given, blueBar: val?.received }));

	return (
		<ResponsiveContainer width="100%" height="100%">
			<BarChart
				data={dataChart}
				margin={{ top: 15, right: 34, left: 10, bottom: 10 }}
				barGap={10} // Adjust the space between bars within the same group
			>
				<CartesianGrid strokeWidth={0.2} stroke="#9e9e9e" vertical={false} horizontal />
				<XAxis dataKey="name" tick={{ fill: '#6C757D', fontSize: 13, fontWeight: 400 }} tickLine={false} axisLine={false} />
				<YAxis dx={-30} orientation="left" tick={{ fill: '#6C757D' }} tickLine={false} axisLine={false} domain={[0, max]} ticks={Array.from({ length: 6 }, (_, i) => Math.floor((max * i) / 5))} tickFormatter={value => value} />
				<Tooltip />
				<Legend content={<CustomLegend />} verticalAlign="top" />
				<Bar dataKey="blueBar" fill="#1191D0" name={t('dashboard-blue-bar-label')} radius={[20, 20, 20, 20]} barSize={15} />
				<Bar dataKey="pinkBar" fill="#FF82AC" name={t('dashboard-pink-bar-label')} radius={[20, 20, 20, 20]} barSize={15} />
			</BarChart>
		</ResponsiveContainer>
	);
};

export default CustomBarChart;
